<button
  type="button"
  class="lang"
  [attr.aria-label]="'LANG_PICKER.LABEL' | translate"
  [cdkMenuTriggerFor]="langMenu"
  [cdkMenuPosition]="positions"
  data-testid="lang-trigger"
>
  <i class="ls-ic ls-globe ic-13" aria-hidden="true"></i>
  {{ langService.currentLang().flag }} {{ langService.currentLang().label }}
</button>

<ng-template #langMenu>
  <div class="lang-menu" cdkMenu [attr.aria-label]="'LANG_PICKER.MENU_LABEL' | translate" data-testid="lang-menu">
    <div cdkMenuGroup>
      @for (option of langOptions; track option.value) {
        <button
          type="button"
          class="lang-menu-item"
          cdkMenuItemRadio
          [class.active]="langService.currentLang().value === option.value"
          [cdkMenuItemChecked]="langService.currentLang().value === option.value"
          (cdkMenuItemTriggered)="langService.switchLang(option.value)"
          [attr.data-testid]="'lang-option-' + option.value"
        >
          <span class="flag" aria-hidden="true">{{ option.flag }}</span>
          <span class="label">{{ option.label }}</span>
        </button>
      }
    </div>
  </div>
</ng-template>
